import { NOTIFICATIONS, NOTIFICATIONS_INCLUDE, NOTIFICATIONS_EXCLUDE } from '@store/types'
import shortly from 'vuex-shortly'

const state = {
  notifications: []
}

const getters = {
  [NOTIFICATIONS]: 'notifications'
}

const mutations = {
  [NOTIFICATIONS]: 'notifications'
}

const actions = {
  [NOTIFICATIONS_INCLUDE]: ({ commit, getters, dispatch }, payload) => {
    const isError = payload instanceof Error
    const notification = {
      type: payload.type || (isError ? 'error' : 'info'),
      message: payload.message || payload
    }
    const notifications = [ ...getters[NOTIFICATIONS], notification ]

    commit(NOTIFICATIONS, notifications)

    setTimeout(() => {
      dispatch(NOTIFICATIONS_EXCLUDE, notification)
    }, 5000)
  },

  [NOTIFICATIONS_EXCLUDE]: ({ commit, getters }, payload) => {
    const notifications = getters[NOTIFICATIONS]
      .filter(notification => notification !== payload)

    commit(NOTIFICATIONS, notifications)
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/notifications.js